import { AutogenLayoutSUITaxableWagesReport } from "./autogen/AutogenLayoutSUITaxableWagesReport";
import { DataSourceExecutionEvent, ChangeEvent } from "@mcleod/components";

export class SUITaxableWagesReport extends AutogenLayoutSUITaxableWagesReport {

    override onLoad() {
        this.checkboxReverseVoids.checked = true;
    }

    /** This is an event handler for the beforeExecution event of sourceSuiTaxableWages. */
    sourceSuiTaxableWagesBeforeExecution(event: DataSourceExecutionEvent) {
        event.filter.includeOffice = 'N';
        event.filter.includeSettlemts = 'Y';
        event.filter.thisTable = "drs_payroll_hist";
    }
}
